export default "__VITE_ASSET__BkRCCKtK__"